export default function getComunas() {
  return [
    "(radio urbano)",
    "Viña del mar",
    "Valparaíso",
    "Concón",
    "Casablanca",
    "San Antonio",
    "Cartagena",
    "Villa Alemana",
    "Quilpué",
    "Rancagua",
    "Graneros (radio urbano)",
    "Codegua (radio urbano)",
    "Machali (radio urbano)",
    "Rengo",
    "San Vicente de Tagua Tagua",
    "San Fernando",
    "Santa Cruz",
    "La serena",
    "Coquimbo",
    "Concepción",
    "Talcahuano",
    "Hualpén",
    "San pedro de la paz",
    "Chiguayante",
    "Cerrillos",
    "Cerro Navia",
    "Conchalí",
    "El Bosque",
    "Estación Central",
    "Huechuraba",
    "Independencia",
    "La Cisterna",
    "La Florida",
    "La Granja",
    "La Pintana",
    "La Reina",
    "Las Condes",
    "Lo Barnechea",
    "Lo Espejo",
    "Lo Prado",
    "Macul",
    "Maipú",
    "Ñuñoa",
    "Pedro Aguirre Cerda",
    "Peñalolén",
    "Providencia",
    "Pudahuel",
    "Quilicura",
    "Quinta Normal",
    "Recoleta",
    "Renca",
    "Santiago",
    "San Joaquín",
    "San Miguel",
    "San Ramón",
    "Vitacura",
    "Puente Alto",
    "Pirque",
    "San José de Maipo",
    "Colina",
    "Lampa",
    "San Bernardo",
    "Buin",
    "Calera de Tango",
    "Paine",
    "Melipilla",
    "Curacaví",
    "María Pinto",
    "Talagante",
    "El Monte",
    "Isla de Maipo",
    "Padre Hurtado",
    "Peñaflor",
  ];
}
